import React from 'react';

/**
 * Stamp-style button. Variant classes live in index.css and carry their
 * own persistent tilt; here we only assemble the class list.
 * Export name kept as `PixelButton` for backward-compatible imports.
 */
const sizes = {
  sm: 'px-3 py-1 text-xs',
  md: 'px-5 py-2 text-sm',
  lg: 'px-8 py-3 text-base',
};

// Explicit map so Tailwind's content scanner sees the full class names.
const variantClasses = {
  primary: 'stamp-btn-primary',
  danger: 'stamp-btn-danger',
  success: 'stamp-btn-success',
  ghost: 'stamp-btn-ghost',
  blue: 'stamp-btn-blue',
};

export default function PixelButton({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  size = 'md',
  pulse = false,
  className = '',
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${variantClasses[variant] ?? variantClasses.primary} ${sizes[size]} ${pulse ? 'stamp-pulse' : ''} ${className}`}
    >
      {children}
    </button>
  );
}
